import { useSelector } from 'react-redux';
import { MetricTypes } from '@pulse/metrics';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { isAppModule } from '@utils/constants';
import {
  ECO_PRESET_KEY,
  getUseCaseLimitation,
} from '@src/components/common/Dashboard/UseCases/limitation';

const filterMetricsOnUseCaseKey = (metrics: Record<string, any>, usecaseKey: string) => {
  const filterMetrics = {} as Record<string, any>;

  if (usecaseKey !== ECO_PRESET_KEY.APP_NETWORK_PERFORMANCE) {
    const excludeTypes = [MetricTypes.appEventMetrics];
    for (const key in metrics) {
      const { type: metricType } = metrics[key] || {};
      if (!excludeTypes.includes(metricType)) {
        filterMetrics[key] = metrics[key];
      }
    }
    return filterMetrics;
  }
  return metrics;
};

export const useSupportedMetrics = (metrics: Record<string, any> = {}) => {
  const { usecaseKey } = useSelector(activeDashboardSelector);
  const limitation = getUseCaseLimitation(usecaseKey);
  if (isAppModule) {
    const filterMetrics = {} as Record<string, any>;

    if (!limitation) {
      return filterMetricsOnUseCaseKey(metrics, usecaseKey);
    }
    const {
      excludeCategories = [],
      excludeKeys = [],
      excludeTypes = [],
    } = limitation?.metrics || {};
    for (const key in metrics) {
      const { type: metricType, category: metricCategory } = metrics[key] || {};
      if (
        !excludeCategories.includes(metricCategory) &&
        !excludeKeys.includes(key) &&
        !excludeTypes.includes(metricType)
      ) {
        filterMetrics[key] = metrics[key];
      }
    }
    return filterMetrics;
  }

  return metrics;
};
